// Emil Kowalski-style easing: custom curves, not built-in CSS.
// "The built-in easing curves in CSS are usually not strong enough."
// Strong ease-out: starts fast, decelerates hard. 200ms max for standard UI.
export const EASE_OUT = [0, 0, 0.35, 1] as const;

export const SPRING_SNAPPY = { type: "spring" as const, stiffness: 500, damping: 30, mass: 0.8 };
export const SPRING_BOUNCY = { type: "spring" as const, stiffness: 400, damping: 22, mass: 0.8 };
export const PROGRESS_SPRING = { type: "spring" as const, stiffness: 100, damping: 20, mass: 0.5 };

export const HEIGHT_DURATION = 0.2;
export const HEIGHT_TWEEN = { duration: HEIGHT_DURATION, ease: EASE_OUT };

export const FADE_FAST = { duration: 0.12, ease: EASE_OUT };
export const FADE_NORMAL = { duration: 0.2, ease: EASE_OUT };

export const STEP_STAGGER_DELAY = 0.06;

export const CHECK_POP = { type: "spring" as const, stiffness: 500, damping: 15, mass: 0.6 };
